import byIdMaker from 'reducersMakers/byIdMaker';
import * as actions from 'actions';

export default byIdMaker({
  fetchSuccessTypes: [actions.USER_AVATARS_FETCH_SUCCESS],
  resetType: actions.USER_AVATARS_FETCH,
  entityType: 'userAvatars'
});



/** WEBPACK FOOTER **
 ** ./src/members/state/user/avatars/byId/reducer.js
 **/